// Module
var code = "<h2 id=\"account-is-60-or-more-days-delinquent\">Account is 60 or More Days Delinquent</h2> <p>If your account is 60 or more days delinquent and you need to make immediate payment arrangements, please contact us. Our customer service representatives will be happy to assist you. </p> ";
// Exports
export default code;